// Instellingen als overzicht (Frans). Zelfde vorm als settingsHub.nl.ts.
export const appSettingsHubFr = {
    groups: {
        family: {
            title: 'Notre famille',
            titleHouse: 'Notre foyer',
            body: 'Qui en fait partie, la langue et ce qui vous convient.',
        },
        agenda: {
            title: 'Agenda',
            body: 'Ajouter des agendas extérieurs, partager et exporter.',
        },
        board: {
            title: 'Tableau et tablettes',
            body: 'Les tablettes au mur, les pièces, le verrou et la météo.',
        },
        modules: {
            title: 'Modules',
            body: 'Les parties que vous utilisez, chacune avec ses propres réglages.',
        },
        account: {
            title: 'Votre compte',
            body: 'Connexion et sécurité, notifications sur votre téléphone et apparence de l’application.',
        },
        privacy: {
            title: 'Confidentialité et données',
            body: 'Télécharger ou effacer vos données, et qui peut regarder.',
        },
    },
    household: {
        title: 'Foyer',
        intro: 'Nom, langue et type de foyer au même endroit.',
        nameTitle: 'Nom et fuseau horaire',
        nameBody: 'Le nom apparaît sur le tableau et dans les e-mails.',
    },
    calendar: {
        title: 'Relier et exporter l’agenda',
        intro: 'Liens d’abonnement, temps de trajet et l’agenda en fichier.',
    },
    locationWeather: {
        title: 'Lieu et météo',
        intro: 'Où vous habitez, et ce que le tableau montre de la météo.',
    },
    // WP3: vijf onderdelen, Bord en Gezin met tabbladen.
    sections: {
        label: 'Rubriques des réglages',
        household: 'Foyer',
        family: 'Famille et traditions',
        house: 'Ce qui convient à notre foyer',
        agenda: 'Agenda',
        modules: 'Modules',
        account: 'Compte et confidentialité',
        accountState: 'Sécurité, notifications, thème et vos données',
    },
    change: 'Modifier',
    /** Rechts in een regel die alleen uitleg opent (geen keuze). */
    view: 'Voir',
    rows: {
        name: 'Nom et fuseau horaire',
        language: 'Langue',
        type: 'Type de foyer',
        location: 'Lieu',
        weather: 'Météo sur le tableau',
        feeds: 'Agendas externes',
        feedsState: 'École, sport et travail dans votre agenda',
        sync: 'Connecter Google ou Outlook',
        syncState: 'Dans les deux sens, par personne',
        links: 'Liens d’abonnement',
        linksState: 'Votre agenda dans une autre app (sens unique)',
        export: 'Exporter',
        exportState: 'L’agenda en fichier (.ics)',
        theme: 'Thème et pictogrammes',
        about: 'À propos d’AMUMIN',
        off: 'Désactivé',
        nothing: 'Rien de choisi pour l’instant',
        ownChoices: 'Choix personnels : {names}',
    },
    hubs: {
        board: {
            title: 'Tableau',
            tabs: 'Rubriques du tableau',
            view: 'Affichage',
            tablets: 'Tablettes',
            rooms: 'Pièces',
            frame: 'Cadre photo',
            kidLock: 'Verrou enfants',
        },
        family: {
            title: 'Famille',
            tabs: 'Rubriques de la famille',
            members: 'Membres',
            links: 'Proches',
            circle: 'Cercle',
        },
    },
    tablets: {
        none: 'Aucune tablette connectée.',
        guide: 'Connecter un iPad',
    },
    members: {
        order: 'Ordre',
        orderDone: 'Terminé',
    },
    modulesCount: '{on} sur {total} activés',
    privacyStatement: 'Déclaration de confidentialité',
    privacyStatementBody: 'Ce que nous conservons, pourquoi et combien de temps.',
    haptics: {
        label: 'Vibrer au toucher',
        hint: 'Une courte vibration quand tu appuies sur quelque chose (seulement sur un téléphone qui le permet).',
        boardHint: 'Une courte vibration quand quelqu’un appuie sur le tableau. Un iPad ne vibre pas ; on y voit quand même l’appui.',
    },
};
//# sourceMappingURL=settingsHub.fr.js.map